// Study time options for Kollel goal
export enum StudyTimeOptions {
  EarlyMorning = 'EarlyMorning',
  Morning = 'Morning',
  Noon = 'Noon',
  Evening = 'Evening',
  AllDay = 'AllDay',
}
